(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ii-all-products-grid"] && !Shopify.designMode) return;
  try {
    
  class IiInfiniteGrid extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.resource-list--grid') || this.querySelector('.resource-list');
      this.loading = false;
      this.sentinel = document.createElement('div');
      this.sentinel.className = 'ii-all-products-grid__sentinel';
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !this.loading) this.loadMore();
      }, { rootMargin: '600px' });
      this.armSentinel();
    }

    armSentinel() {
      if (!this.dataset.nextUrl) {
        this.observer.disconnect();
        this.sentinel.remove();
        return;
      }
      this.after(this.sentinel);
      this.observer.observe(this.sentinel);
    }

    async loadMore() {
      this.loading = true;
      this.observer.unobserve(this.sentinel);

      try {
        const url = `${this.dataset.nextUrl}${this.dataset.nextUrl.includes('?') ? '&' : '?'}section_id=${this.dataset.sectionId}`;
        const response = await fetch(url);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newRoot = doc.querySelector('ii-infinite-grid');
        const newGrid = newRoot ? newRoot.querySelector('.resource-list--grid, .resource-list') : null;

        if (newGrid && this.grid) {
          [...newGrid.children].forEach((child) => this.grid.appendChild(child));
        }

        this.dataset.nextUrl = newRoot ? newRoot.dataset.nextUrl || '' : '';
      } catch (error) {
        this.dataset.nextUrl = '';
      } finally {
        this.loading = false;
        this.sentinel.remove();
        this.armSentinel();
      }
    }
  }

  customElements.define('ii-infinite-grid', IiInfiniteGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ii-filter-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ii-filter-tabs[data-toggle-target-prefix]').forEach((tabs) => {
    const prefix = tabs.dataset.toggleTargetPrefix;
    if (!prefix) return;

    tabs.querySelectorAll('.ii-filter-tab').forEach((tab) => {
      tab.addEventListener('click', (event) => {
        // JSON-template section wrapper ids are
        // "shopify-section-template--{numeric id}__{section key}", so
        // match by suffix rather than assuming the id starts with "prefix".
        const targetSuffix = tab.dataset.tag ? `__${prefix}_${tab.dataset.tag}` : `__${prefix}`;
        const target = document.querySelector(`[id$="${targetSuffix}"]`);
        if (!target) return;

        event.preventDefault();

        tabs.querySelectorAll('.ii-filter-tab').forEach((t) => {
          t.classList.toggle('ii-filter-tab--active', t === tab);
        });

        document.querySelectorAll(`[id*="__${prefix}"]`).forEach((section) => {
          const isTarget = section.id.endsWith(targetSuffix);
          section.hidden = !isTarget;
          // The FOUC-prevention stylesheet rule above (a plain attribute
          // selector, no !important) permanently forces display: none on
          // every non-base grid — removing the [hidden] attribute alone
          // doesn't override that separate rule, so the target needs an
          // explicit inline value to actually win the cascade.
          section.style.display = isTarget ? 'revert' : '';
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ii-help-jump-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ii-help-jump]').forEach((jumpBar) => {
    const links = [...jumpBar.querySelectorAll('.ii-help-jump__link')];
    if (!links.length) return;

    const setJumpHeight = () => {
      document.documentElement.style.setProperty('--ii-help-jump-height', `${jumpBar.offsetHeight}px`);
    };
    setJumpHeight();
    new ResizeObserver(setJumpHeight).observe(jumpBar);

    const sections = links
      .map((link) => document.getElementById(link.dataset.anchor))
      .filter(Boolean);
    if (!sections.length) return;

    const setActive = (id) => {
      links.forEach((link) => {
        link.classList.toggle('ii-help-jump__link--active', link.dataset.anchor === id);
      });
    };
    setActive(sections[0].id);

    // Track which sections are currently intersecting rather than acting on
    // each observer entry in isolation — a batch can report more than one
    // section intersecting at once (e.g. right after a jump-link scroll
    // lands between two sections), and entries aren't guaranteed to arrive
    // in DOM order, so blindly calling setActive per-entry lets whichever
    // one happens to fire last in that batch win arbitrarily. Keeping a
    // running set and always picking the last (furthest down the page) of
    // the currently-intersecting sections matches the "topmost visible
    // section is the active one" intent consistently.
    const intersecting = new Set();
    const updateActive = () => {
      for (let i = sections.length - 1; i >= 0; i -= 1) {
        if (intersecting.has(sections[i].id)) {
          setActive(sections[i].id);
          return;
        }
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            intersecting.add(entry.target.id);
          } else {
            intersecting.delete(entry.target.id);
          }
        });
        updateActive();
      },
      { rootMargin: '-130px 0px -70% 0px' }
    );
    sections.forEach((section) => observer.observe(section));

    jumpBar.querySelectorAll('.ii-help-jump__link').forEach((link) => {
      link.addEventListener('click', () => setActive(link.dataset.anchor));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
